import { render, staticRenderFns } from "./CreateDetail.vue?vue&type=template&id=50bfe10c&scoped=true"
import script from "./CreateDetail.vue?vue&type=script&lang=js"
export * from "./CreateDetail.vue?vue&type=script&lang=js"
import style0 from "./CreateDetail.vue?vue&type=style&index=0&id=50bfe10c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bfe10c",
  null
  
)

export default component.exports